import { Dispatch, FC } from 'react';
import { Box, Checkbox } from 'components';
import { useTranslation } from 'react-i18next';

interface MultiSelectFilterProps {
    options: string[];
    filter: any;
    set: Dispatch<any>;
}

const MultiSelectFilter: FC<MultiSelectFilterProps> = ({
    options,
    filter,
    set
}) => {
    const { t } = useTranslation();

    const onItemSelected = (selectedFilter: string) => {
        const temp = [...(filter?.value ?? [])];
        const index = temp.findIndex((value: any) => value === selectedFilter);

        if (index !== -1) {
            temp.splice(index, 1);
        } else {
            temp.push(selectedFilter);
        }

        set({ value: temp });
    };

    return (
        <Box>
            {options.map((option, index) => (
                <Checkbox
                    key={index}
                    isFullWidth={true}
                    isChecked={
                        filter?.value
                            ? filter.value.some((f: string) => f === option)
                            : false
                    }
                    onChange={() => onItemSelected(option)}
                    label={t(`filter_options.${option}`)}
                />
            ))}
        </Box>
    );
};

export default MultiSelectFilter;
